import { render, staticRenderFns } from "./NavLinks.vue?vue&type=template&id=5e3ffed1&scoped=true&"
import script from "./NavLinks.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NavLinks.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NavLinks.vue?vue&type=style&index=0&id=5e3ffed1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3ffed1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e3ffed1')) {
      api.createRecord('5e3ffed1', component.options)
    } else {
      api.reload('5e3ffed1', component.options)
    }
    module.hot.accept("./NavLinks.vue?vue&type=template&id=5e3ffed1&scoped=true&", function () {
      api.rerender('5e3ffed1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/SearchBar/components/NavLinks.vue"
export default component.exports